import React from "react";

// Tiny fixed badge showing whether you're on Preview or the Live deployment.
// Helps avoid panic during the brief 520s of a production redeploy.
export function VersionStamp() {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isPreview = host.includes("preview.emergent") || host.includes("localhost");
  const env = isPreview ? "Preview" : "Live";
  return (
    <div
      data-testid="version-stamp"
      title={`Environment: ${env} · ${host}`}
      className={`fixed bottom-2 left-2 z-[60] select-none rounded-full px-2 py-0.5 text-[10px] font-semibold shadow-sm ${
        isPreview ? "bg-amber-500/20 text-amber-600" : "bg-emerald-500/20 text-emerald-600"
      }`}
    >
      {env}
    </div>
  );
}
